var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "118px",
    height: "119px",
    viewBox: "0 0 118 119",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "9.83333333e-05 0.804563333 117.195633 0.804563333 117.195633 118 9.83333333e-05 118"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 118.178967 117.195633 118.178967 117.195633 0.983333333 0 0.983333333"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avenu---Visual-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-Homepage-large-screen",
    transform: "translate(-1261.000000, -4817.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(1261.000000, 4817.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.178967)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.597915,0.804563333 C90.9603983,0.804563333 117.195732,27.0398967 117.195732,59.40238 C117.195732,91.7648633 90.9603983,118.000197 58.597915,118.000197 C26.2354317,118.000197 9.83333333e-05,91.7648633 9.83333333e-05,59.40238 C9.83333333e-05,27.0398967 26.2354317,0.804563333 58.597915,0.804563333",
    id: "Fill-1",
    fill: "#275472",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#27BFC5",
    mask: "url(#mask-4)",
    points: "50.7557333 96.4905667 88.8874333 96.4905667 88.8874333 51.0999 50.7557333 51.0999"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "34.0489 96.4876167 74.6005833 96.4876167 74.6005833 25.0632 34.0489 25.0632"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#E0F2FF",
    mask: "url(#mask-4)",
    points: "54.2927833 96.4876167 74.6015667 96.4876167 74.6015667 25.0632 54.2927833 25.0632"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#2CDDDD",
    mask: "url(#mask-4)",
    points: "39.6952 43.0355833 50.75475 43.0355833 50.75475 31.9760333 39.6952 31.9760333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#27BFC5",
    mask: "url(#mask-4)",
    points: "57.8967 43.0355833 68.95625 43.0355833 68.95625 31.9760333 57.8967 31.9760333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#2CDDDD",
    mask: "url(#mask-4)",
    points: "39.6952 58.4739167 50.75475 58.4739167 50.75475 47.4143667 39.6952 47.4143667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#27BFC5",
    mask: "url(#mask-4)",
    points: "57.8967 58.4739167 68.95625 58.4739167 68.95625 47.4143667 57.8967 47.4143667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#2CDDDD",
    mask: "url(#mask-4)",
    points: "39.6952 73.9102833 50.75475 73.9102833 50.75475 62.8507333 39.6952 62.8507333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#27BFC5",
    mask: "url(#mask-4)",
    points: "57.8967 73.9102833 68.95625 73.9102833 68.95625 62.8507333 57.8967 62.8507333"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#27BFC5",
    mask: "url(#mask-4)",
    points: "47.4143667 96.4886 61.23905 96.4886 61.23905 77.5958167 47.4143667 77.5958167"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#2CDDDD",
    mask: "url(#mask-4)",
    points: "54.2927833 96.4886 61.2380667 96.4886 61.2380667 77.5958167 54.2927833 77.5958167"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset28);
export default __webpack_public_path__ + "static/media/asset-28.e3c91c8bc6bee2d925d03a7be332f76d.svg";
export { ForwardRef as ReactComponent };